import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetRegistrationUpdateStatus,
	GetRegistrationUpdateStatusModel,
	GetRegistrationUpdateStatusParams,
} from 'domain/usecases/private/home/registration-update-status';

export class RemoteGetRegistrationUpdateStatus implements GetRegistrationUpdateStatus {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRegistrationUpdateStatusModel>,
	) {}

	async get({
		signal,
	}: GetRegistrationUpdateStatusParams): Promise<GetRegistrationUpdateStatusModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
